import React from 'react';
import { withTheme } from 'styled-components';
import { localize } from 'core/localization';
import { SVG_XML_NAMESPACE } from 'constants/common';
import { Figure } from './Figure.styled';

type TimeOutProps = {
  theme: { [key: string]: any };
};

export const TimeOut = (props: TimeOutProps) => (
  <Figure
    width="260"
    height="132"
    viewBox="0 0 260 132"
    version="1.1"
    xmlns={SVG_XML_NAMESPACE}
    role="img"
    arialabel={`${localize('[aria label timeout image alt]')}`}
  >
    <defs>
      <filter
        id="filter-1"
        width="100%"
        height="100%"
        x="0%"
        y="0%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur in="SourceGraphic" />
      </filter>
      <filter
        id="filter-2"
        width="100%"
        height="100%"
        x="0%"
        y="0%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur in="SourceGraphic" />
      </filter>
      <path id="path-1" d="M60.567 10.928H68.56700000000001V18.928H60.567z" />
      <path
        id="path-2"
        d="M40 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm0 2c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g fill={props.theme.colors.textColor} transform="translate(0 37)">
        <path
          d="M74.48.423H20.984s-9.378 1.012-9.378 8.467c0 7.454 9.378 8.466 9.378 8.466l31.828.06s7.447 1.452 7.447 7.983c0 6.53-7.447 8.466-7.447
          8.466H36.368s-13.348.815-13.348 8.89c0 8.074 13.348 9.312 13.348 9.312H9.479S0 53.7 0 60.473C0 67.246 9.48 69 9.48
          69h207.865s11.703-1.33 11.703-8.527c0-7.196-11.703-8.406-11.703-8.406H197.02s-11.868-.707-12.08-8.042c-.211-7.336
          12.08-8.709 12.08-8.709l23.586-.816s12.31 1.814 12.31-8.376-11.325-8.768-11.325-8.768l28.253.06S260 16.806 260 8.89C260 .973 249.844 0 249.844 0L74.479.423z"
          filter="url(#filter-1)"
          opacity=".02"
        />
        <ellipse cx="130" cy="91" filter="url(#filter-2)" opacity=".1" rx="35" ry="4" />
      </g>
      <g transform="translate(90)">
        <path
          fill={props.theme.colors.mainColor}
          d="M40 14c7.127 0 13.82 1.864 19.615 5.131l1.653-2.863 3.464 2L63 21.27C73.282 28.508 80 40.47 80 54c0 22.091-17.909 40-40 40S0 76.091 0
          54s17.909-40 40-40zm0 6C21.222 20 6 35.222 6 54s15.222 34 34 34 34-15.222 34-34-15.222-34-34-34zm2-10v4h-4v-4h4z"
        />
        <circle cx="40" cy="54" r="34" fill={props.theme.colors.contentBodyColor} />
        <path
          fill={props.theme.colors.textColor}
          d="M41 80v6h-2v-6h2zm-10.366-4.098l1.732 1-3 5.196-1.732-1 3-5.196zm19.732 0l3 5.196-1.732 1-3-5.196 1.732-1zm7.61-5.055l4.242 4.242-1.414
          1.415-4.243-4.243 1.414-1.414zm-35.562-.675l1.414 1.414-4.242 4.242-1.414-1.414 4.242-4.242zm-6.316-6.538l1 1.732-5.196 3-1-1.732 5.196-3zm46.804-1l5.196 3-1
          1.732-5.196-3 1-1.732zM14 53v2H8v-2h6zm58 0v2h-6v-2h6zm-4.902-11.366l1 1.732-5.196 3-1-1.732 5.196-3zm-55.196-2l5.196 3-1 1.732-5.196-3 1-1.732zm48.512-7.462l1.414
          1.414-4.242 4.242-1.414-1.414 4.242-4.242zm-41.345-.747l4.242 4.242-1.414 1.415-4.243-4.243 1.415-1.414zm31.565-6.523l1.732 1-3 5.196-1.732-1 3-5.196zm-22.268 0l3
          5.196-1.732 1-3-5.196 1.732-1zM41 22v6h-2v-6h2z"
        />
        <path
          fill={props.theme.colors.mainColor}
          d="M36.207 23.447l7.045 31.628c.131.589.02 1.205-.307 1.712l-.461.713.84 4.378c.194 1.016-.457
          2.002-1.468 2.222-.035.008-.07.014-.105.02-.955.147-1.849-.507-1.996-1.462l-.759-4.915-.8-.94c-.326-.38-.514-.858-.537-1.358l-1.452-31.998zm4.408
          28.255c-.882-.236-1.794.31-2.038 1.22-.244.91.273 1.839 1.155 2.075.882.236 1.794-.31 2.038-1.22.244-.91-.273-1.839-1.155-2.075zM38 10H42V14H38z"
        />
        <g transform="rotate(30 64.567 14.928)">
          <use fill={props.theme.colors.mainColor} xlinkHref="#path-1" />
          <use fill="#000" fillOpacity=".1" xlinkHref="#path-1" />
        </g>
        <use fill={props.theme.colors.mainColor} xlinkHref="#path-2" />
        <use fill="#000" fillOpacity=".1" xlinkHref="#path-2" />
      </g>
    </g>
  </Figure>
);

export default withTheme(TimeOut);
